<template>
  <div class="page-content">
    <div class="is-flex" :class="{'flex-dir-col': !isDesktop}">
      <div class="left-box">
        <div :class="{'margin-bottom-61':isDesktop, 'margin-bottom-30':isTablet, 'margin-bottom-19':isMobile}">
          <div class="lb_head">
            <span class="has-text-weight-semibold">Review of</span>
            <router-link :to="{ name: 'BusinessDetail', params: { slug: business } }" class="link--v2">{{ bizname }}</router-link>
          </div>
          <biz-performance :industries="industryRankSorted" v-if="!isDesktop" class="biz-perf"/>
          <template v-if="!isMobileAds">
            <!-- <ad v-on:ad-loaded="updateAdsListForPage" :ad-object="firstAd" :no-margin="hideFirstDesktopAd"></ad> -->
            <p class="has-text-centered">
              <fuse-ad name="review_detail_header" v-on:ad-loaded="updateAdsListForPage"></fuse-ad>
              <!-- <ad v-on:ad-loaded="updateAdsListForPage" :ad-object="secondAd"></ad> -->
            </p>
          </template>
          <template v-else>
            <p class="has-text-centered">
              <fuse-ad name="review_detail_MREC" v-on:ad-loaded="updateAdsListForPage"></fuse-ad>
              <!-- <ad v-on:ad-loaded="updateAdsListForPage" :ad-object="firstAd"></ad> -->
            </p>
          </template>
          <loader v-if="fetching_data"/>
          <review-card-v2 v-else-if="reviewDetail" v-bind:review.sync="reviewDetail" v-bind:messages.sync="reviewDetail.messages" :messagesCount="reviewDetail.messages.length" :itemProps="true"
                          :class="{'margin-left-11': isTablet, 'margin-right-36': isTablet}"/>
        </div>

        <div :class="{'margin-bottom-28': isDesktop, 'margin-bottom-26': isTablet,'font-size-12': isMobile, 'margin-bottom-18': isMobile}" v-if="sameBizReviews.reviews.length || sameIndusReviews.reviews.length">
          <div v-if="sameBizReviews.reviews.length" data-nosnippet>
            <div :class="{'margin-bottom-45': isDesktop, 'margin-bottom-34': isTablet, 'margin-left-14': isTablet, 'margin-left-15': isMobile, 'margin-bottom-26': isMobile}">
              <span :class="{'has-text-weight-semibold': !isMobile}">Other reviews from</span>
              <router-link :to="{ name: 'BusinessDetail', params: { slug: business } }" class="link--v2">{{ bizname }}</router-link>
            </div>
            <fuse-ad v-if="!isMobileAds" name="review_detail_incontent_1" v-on:ad-loaded="updateAdsListForPage"></fuse-ad>
            <fuse-ad v-if="isMobileAds" name="review_detail_mobile_hrec_1" v-on:ad-loaded="updateAdsListForPage"></fuse-ad>
            <VueSlickCarousel :variableWidth="true" :slidesToShow="1" :slidesToScroll="1" :infinite="true" :arrows="isDesktop">
              <biz-other-review-card v-for="(review, key) in sameBizReviews.reviews" :key="key" :review="review"/>
              <template #prevArrow="arrowOption">
                <carousel-arrow dir="left"/>
              </template>
              <template #nextArrow="arrowOption">
                <carousel-arrow dir="right"/>
              </template>
            </VueSlickCarousel>
          </div>
          <div class="separator" v-if="sameBizReviews.reviews.length && sameIndusReviews.reviews.length"></div>
          <fuse-ad v-if="!isMobileAds" name="review_detail_incontent_2" v-on:ad-loaded="updateAdsListForPage"></fuse-ad>
          <fuse-ad v-if="isMobileAds" name="review_detail_mobile_hrec_2" v-on:ad-loaded="updateAdsListForPage"></fuse-ad>
          <div v-if="sameIndusReviews.reviews.length" data-nosnippet>
            <div :class="{'margin-bottom-34': isTablet, 'margin-bottom-39': isDesktop, 'margin-left-15': isMobile, 'margin-bottom-18': isMobile}">
              <span :class="{'has-text-weight-semibold': !isMobile}">Reviews from other</span>
              <router-link :to="{ name: 'Industries-Category', params: { slug: sameIndusReviews.indusSlug } }" class="link--v2">{{ sameIndusReviews.indusName }}</router-link>
              <span :class="{'has-text-weight-semibold': !isMobile}">&nbsp;businesses</span>
            </div>
            <VueSlickCarousel :variableWidth="true" :slidesToShow="1" :slidesToScroll="1" :infinite="true" :arrows="isDesktop">
              <biz-review-card v-for="(review, key) in sameIndusReviews.reviews" :key="key" :review="review" :miniView="true"/>
              <template #prevArrow="arrowOption">
                <carousel-arrow dir="left"/>
              </template>
              <template #nextArrow="arrowOption">
                <carousel-arrow dir="right"/>
              </template>
            </VueSlickCarousel>
          </div>
        </div>
      </div>
      <div class="right-box">
        <div v-if="isMobileAds" class="has-text-centered">
          <!-- <fuse-ad name="review_detail_MREC" v-on:ad-loaded="updateAdsListForPage"></fuse-ad> -->
          <!-- <ad :ad-object="secondAd" v-on:ad-loaded="updateAdsListForPage"></ad> -->
          <!-- <ad :ad-object="thirdAd" v-on:ad-loaded="updateAdsListForPage"></ad> -->
        </div>
        <template v-else>
          <fuse-ad name="review_detail_MREC" v-on:ad-loaded="updateAdsListForPage"></fuse-ad>
          <!-- <ad :ad-object="thirdAd" v-on:ad-loaded="updateAdsListForPage" class="has-text-centered" v-if="isDesktop"></ad> -->
          <div v-if="industryRankSorted.length" class="rb__indus-rank">
            <div class="has-text-weight-bold color-blue-dark margin-bottom-24">See how this business has been performing on Hellopeter:</div>
            <rank-in-industries :industries="industryRankSorted"/>
          </div>
          <p class="has-text-centered">
            <fuse-ad name="review_detail_vrec_rhs" v-on:ad-loaded="updateAdsListForPage" :vertical-sticky="verticalSticky"></fuse-ad>
          </p>
          <!-- <ad :ad-object="fifthAd" v-on:ad-loaded="updateAdsListForPage" class="has-text-centered"></ad> -->
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Loader,
  Ad,
  FuseAd,
  CarouselArrow,
  RankInIndustries,
  BizPerformance
} from '@/components'
import {ReviewCardV2, BizReviewCard, BizOtherReviewCard} from '@/components/reviewCards'
import {auth, misc, adConfig} from '@/mixins'
import axios from 'axios'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
  name: 'ReviewDetail',
  props: {
    business: {
      type: String
    },
    permalink: {
      type: String
    }
  },
  mixins: [auth, misc, adConfig],
  components: {
    BizPerformance,
    RankInIndustries,
    BizReviewCard,
    Ad,
    FuseAd,
    ReviewCardV2,
    Loader,
    VueSlickCarousel,
    BizOtherReviewCard,
    CarouselArrow
  },
  data () {
    return {
      verticalSticky: true,
      reviewDetail: null,
      fetching_data: false,
      sameBizReviews: {
        reviews: []
      },
      sameIndusReviews: {
        indusName: '',
        indusSlug: '',
        reviews: []
      },
      industryRankSorted: []
    }
  },
  computed: {
    bizname () {
      if (this.reviewDetail !== null) {
        return this.reviewDetail.business_name
      }
      return ""
    },
    meta_title () {
      if (typeof this.reviewDetail !== 'undefined' && this.reviewDetail !== null) {
        if (this.reviewDetail.review_rating >= 4) {
          return `[Happy Customer] ${this.reviewDetail.review_title} - ${this.reviewDetail.review_rating} stars | ${this.bizname}`
        } else {
          if (this.reviewDetail.replied) {
            return `[Responded] ${this.reviewDetail.review_title} - ${this.reviewDetail.review_rating} stars | ${this.bizname}`
          }
          return `[Unhappy Customer] ${this.reviewDetail.review_title} - ${this.reviewDetail.review_rating} stars | ${this.bizname}`
        }
      }
      return ''
    },
    og_title () {
      if (typeof this.reviewDetail !== 'undefined' && this.reviewDetail !== null) {
        if (this.reviewDetail.consumerCompetitions.includes('20k')) {
          return "WIN R20,000 by Giving a Business Their First Hellopeter Review"
        } else {
          return `${this.reviewDetail.author} gave ${this.bizname} ${this.reviewDetail.review_rating} star${this.reviewDetail.review_rating > 1 ? 's' : ''}. Check out the full review...`
        }
      }
      return ''
    },
    meta_description () {
      if (this.reviewDetail !== null && this.reviewDetail.review_rating) {
        return `${this.reviewDetail.author} - ` + this.reviewDetail.review_content.replace(/<(?:.|\n)*?>/gm, '')
      }
      return ''
    },
    og_description () {
      if (this.reviewDetail !== null) {
        if (this.reviewDetail.consumerCompetitions.includes('20k')) {
          return "Review a business not yet listed on hellopeter.com, and you could WIN R20,000 cash. 12 months. 12 chances to win. T&CS apply"
        } else if (this.reviewDetail.review_rating) {
          return this.reviewDetail.review_content.replace(/<(?:.|\n)*?>/gm, '').substring(0, 150) + `...`
        }
      }
      return ''
    },
    businessSlug () {
      if (this.reviewDetail !== null) {
        return `${this.reviewDetail.business_slug}`
      }
      return ''
    },
    openGraphBanner () {
      if (this.reviewDetail !== null) {
        //return `${this.reviewDetail.details.og_url}`
        // href: `${window.location.protocol}//${window.location.host}/${this.record.businessDetails.slug}`
        return `${window.location.protocol}//${window.location.host}/reviews/${this.reviewPermalink}`
      }
      return ''
    },
    industryLogo () {
      if (this.reviewDetail !== null) {
        return `${this.reviewDetail.industry_logo}`
      }
      return ''
    },
    reviewPermalink () {
      if (this.reviewDetail !== null) {
        return `${this.reviewDetail.permalink}`
      }
      return ''
    },
    getCanonicalUrl () {
      return [
        {
          rel: 'canonical',
          href: `${window.location.protocol}//${window.location.host}/${this.businessSlug}/reviews/${this.reviewPermalink}`
        }
      ]
    }
  },
  created () {
    if (this.$route !== 'undefined') {
      this.doneFetchingDependantData = false
    } else {
      this.doneFetchingDependantData = true
    }
  },
  mounted () {
    setTimeout(() => {
      if (this.$route !== undefined) {
        console.log('calling this.getReviewDetail()')
        this.getReviewDetail()
      }
    }, 100)
    console.log('reviews detail done fetching dependant data value', this.doneFetchingDependantData)
    // this.loadFuseAds()
    // this.loadAds()
  },
  methods: {
    getReviewDetail () {
      this.fetching_data = true
      this.doneFetchingDependantData = false
      axios.get(`/consumer/business/${this.business}/reviews/${this.permalink}`)
        .then(({data}) => {
          this.reviewDetail = data

          this.sameBizReviews = data.sameBizReviews
          this.doneFetchingDependantData = true
          this.sameIndusReviews = data.sameIndusReviews

          if (data.indusRank.length) {
            data.indusRank.sort((a, b) => a.industryRanking - b.industryRanking);
            this.industryRankSorted = data.indusRank
          }

          this.fetching_data = false

          const brandName = data.business_name !== 'undefined' ? data.business_name : ''
          const industryName = data.industry_name !== 'undefined' ? data.industry_name : ''
          this.$gtm.trackEvent({
            event: 'pageLoad',
            virtualPageUrl: this.$router.currentRoute.path,
            virtualPageTitle: this.meta_title,
            brandName: brandName,
            industryName: industryName
          })
          window.prerenderReady = true
          googletag.cmd.push(() => {
            googletag.pubads().setTargeting('Pagetype', this._routeName)
            googletag.pubads().setTargeting('URL', window.location.href)
            if (data.nps_rating !== null) {
              let happyText = 'Unhappy customer'
              if (data.nps_rating === 7 || data.nps_rating === 8) {
                happyText = 'Undecided customer'
              } else if (data.nps_rating === 9 || data.nps_rating === 10) {
                happyText = 'Happy customer'
              }
              googletag.pubads().setTargeting('Customer Type', happyText)
            }
            googletag.pubads().setTargeting('Stars', data.reviewRating)
            googletag.pubads().setTargeting('Brand', data.business_name)
            googletag.pubads().collapseEmptyDivs()
            googletag.enableServices()
          })
        })
        .catch((error) => {
          this.doneFetchingDependantData = true
          if (typeof error !== 'undefined' && typeof error.response !== 'undefined' && typeof error.response.status !== 'undefined') {
            if (error.response.status === 404) {
              window.location.href = '/404'
            } else {
              console.log('stringify error', JSON.stringify(error))
            }
          }
        })
    }
  },
  metaInfo () {
    return {
      title: this.meta_title,
      titleTemplate: '%s on Hellopeter.com',
      meta: [
        {name: 'description', content: this.meta_description},

        {'property': 'og:type', 'content': 'website'},
        {'property': 'og:description', 'content': this.og_description},
        {'property': 'og:image', 'content': 'https://www.hellopeter.com/static/img/logo/hp-fb-crawl-3.png'},
        //{'property': 'og:image', 'content': (encodeURI(this.openGraphBanner) ? encodeURI(this.openGraphBanner) : this.industryLogo)},
        // {'property': 'og:image', 'content': (encodeURI(this.businessLogo) ? encodeURI(this.businessLogo) : this.industryLogo)},
        {'property': 'og:title', 'content': this.og_title},
        {'property': 'og:url', 'content': `${window.location.protocol}//${window.location.host}/${this.businessSlug}/reviews/${this.reviewPermalink}`},

        {'property': 'fb:app_id', 'content': process.env.FACEBOOK_APP_ID}
      ],
      link: this.getCanonicalUrl,
      bodyAttrs: {
        class: 'review'
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/_variables.scss";
@import "@/assets/scss/vendor/_breakpoints.scss";

.page-content {
  max-width: 1354px;
  margin-left: auto;
  margin-right: auto;
  padding: 32px 20px 0 99px;
  color: map-get($colors, 'gray');

  @include not-desktop {
    padding-left: 0;
    padding-right: 0;
    padding-top: 21px;
  }

  .separator {
    margin-top: 54px;
    margin-bottom: 33px;

    @include tablet {
      margin-top: 29px;
    }

    @include mobile {
      margin-top: 23px;
      margin-bottom: 20px;
    }
  }
}

.left-box {
  max-width: calc(100% - 442px);

  @include not-desktop {
    max-width: 100%;
  }

  @include tablet {
    padding-left: 40px;
    padding-right: 31px;
  }

  @include mobile {
    padding-left: 10px;
    padding-right: 10px;
  }

  .biz-perf {
    @include tablet {
      margin-left: 23px;
      margin-top: 28px;
    }

    @include mobile {
      margin-left: 5px;
      margin-right: 5px;
      margin-top: 18px;
    }

    > > > .perf-card {
      @include tablet {
        width: 225px;
        margin-bottom: 0;
      }

      @include mobile {
        font-size: 8.5px;
        padding-left: 10px;
        padding-top: 3px;
        height: 23px;
        margin-bottom: 0;

        .perf-card__head {
          font-size: 10px;
          width: 47px;
        }

        .tooltip-icon {
          width: 10px;
          height: 10px;
          font-size: 7px;
        }
      }
    }
  }

  .lb_head {
    @include tablet {
      margin-left: 26px;
    }

    @include mobile {
      font-size: 12px;
      margin-left: 15px;
    }
  }

  > > > .slick-slider {
    margin-left: -9px;
    margin-right: -6px;

    @include tablet {
      margin-left: -47px;
      margin-right: -31px;
    }

    @include mobile {
      margin-left: -14px;
      margin-right: -5px;
    }

    .slick-list {
      @include tablet {
        padding: 0 37px;
      }

      @include mobile {
        padding: 0 18px;
      }
    }

    .slick-slide {
      width: 272px;
      padding-left: 8.5px;
      padding-right: 8.5px;

      @include tablet {
        width: 237px;
        padding-left: 7px;
        padding-right: 7px;
      }

      @include mobile {
        width: 287px;
        padding-left: 3.5px;
        padding-right: 3.5px;
      }
    }
  }

  .custom-arrow {
    width: 10px;

    img {
      position: absolute;
      top: 0
    }
  }

  .custom-arrow.slick-prev {
    left: -8px;
  }

  .custom-arrow.slick-next {
    right: -16px;
  }
}

.right-box {
  width: 400px;
  margin-left: 42px;
  padding: 10px 34px 10px 33px;
  background-color: #f6f6f6;
  border-radius: 2px;

  @include not-desktop {
    width: 100%;
    margin-left: 0;
  }

  @include tablet {
    display: flex;
    padding: 0 0 0 51px;

    .rb__indus-rank {
      width: 300px;
      margin-top: 21px;
      margin-bottom: 24px;

      #rankingWidget {
        font-size: 14px;
        box-shadow: none;
        padding-bottom: 12px;

        > > > {
          h4 {
            color: map-get($colors, 'gray');
          }

          .separator {
            display: none;

            ~ div .font-size-12 {
              font-size: 14px;

              .link--v2 {
                margin-left: 0;
              }
            }
          }
        }

      }
    }
  }

  @include mobile {
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/reviews/ReviewDetail.vue